<script setup lang="ts">
import { JSON_POLL_INTERVAL } from '@shared/utils/constant'
import {
  restrictedCountries,
  blacklistedAddresses,
  verifiedSpotMarketIdMap
} from '@/app/json'

const jsonStore = useSharedJsonStore()

const emit = defineEmits<{
  'on:loaded': []
}>()

onMounted(() => {
  mountCachedJson()

  pollJson().finally(() => {
    emit('on:loaded')
  })
})

function mountCachedJson() {
  jsonStore.fetchFullTokenList()

  jsonStore.restrictedCountries = restrictedCountries
  jsonStore.blacklistedAddresses = blacklistedAddresses
  jsonStore.verifiedSpotMarketMap = verifiedSpotMarketIdMap
}

function pollJson() {
  return Promise.all([
    jsonStore.fetchToken(),
    jsonStore.fetchChainUpgradeConfig(),
    jsonStore.fetchRestrictedCountries(),
    jsonStore.fetchBlacklistedAddresses(),
    jsonStore.fetchVerifiedSpotMarketMap()
  ])
}

useIntervalFn(pollJson, JSON_POLL_INTERVAL)
</script>

<template>
  <div />
</template>
